import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import useUser from "../../../hooks/useUser";
import { CaseHandlerTypes, MemberReportConfigType } from "../interfaces";
import { getMemberReportConfig, upsertMemberReportConfig } from "../services";
import { capitalize, isEmpty } from "lodash";
import toast from "react-hot-toast";
import { useTranslations } from "use-intl";
import styles from "./index.module.scss";
import MemberReportConfigTabs from "./Tabs/MemberReportConfigTabs";
import { MemberReportTabsEnum } from "../services/constant";
import CaseConfigForm from "./CaseConfig/CaseConfig";
import ProductHiearchyForm from "./ProductHiearchyConfigForm/ProductHierarchyForm";
import CustomerAnalysisPeriodForm from "./CustomerAnalysisPeriodForm/CustomerAnalysisPeriodForm";

export default function MemberReportConfig() {
  const t = useTranslations("memberReportConfig");
  const tCommon = useTranslations("common");
  const user = useUser();
  const { selectedBusiness } = user;
  const [memberReportConfig, setMemberReportConfig] =
    useState<MemberReportConfigType | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tab, setTab] = useState<MemberReportTabsEnum>(
    MemberReportTabsEnum.Recency
  );
  useEffect(() => {
    setIsLoading(true);
    setMemberReportConfig(null);
    getMemberReportConfig(selectedBusiness.id)
      .then((data) => {
        if (isEmpty(data)) {
          setMemberReportConfig(null);
        } else {
          setMemberReportConfig(data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setMemberReportConfig(null);
        setIsLoading(false);
        console.log(err);
      });
  }, [tab, selectedBusiness]);

  const handleMemberReportConfigSave = async (
    configData: MemberReportConfigType
  ) => {
    const newMemberReportConfig: MemberReportConfigType = {
      ...memberReportConfig,
      ...configData,
    };

    return upsertMemberReportConfig(selectedBusiness.id, newMemberReportConfig)
      .then(() => {
        toast.success(t("page.configurationsSaved"));
        setMemberReportConfig(newMemberReportConfig);
      })
      .catch((err) => {
        toast.error(tCommon("somethingWentWrong"));
        console.log(err);
      });
  };
  const business = capitalize(selectedBusiness.name);
  return (
    <Box id={styles.memberReportConfigContainer}>
      <Box className={styles.memberReportConfigTabs}>
        <MemberReportConfigTabs tab={tab} setTab={setTab} />
      </Box>
      <Box>
        {tab === MemberReportTabsEnum.Recency && (
          <Box>
            <CaseConfigForm
              title={t("page.uptoRecencyTitle", { business })}
              description={t("page.usageDescription")}
              configLabel={t("page.daysLabel")}
              configName={CaseHandlerTypes.uptoRecency}
              configData={memberReportConfig}
              handleConfigSave={handleMemberReportConfigSave}
              isLoading={isLoading}
            />
          </Box>
        )}
        {tab === MemberReportTabsEnum.Frequency && (
          <Box>
            <CaseConfigForm
              title={t("page.withinFrequencyTitle", { business })}
              description={t("page.usageDescription")}
              configLabel={t("page.visitsLabel")}
              configName={CaseHandlerTypes.withinFrequency}
              configData={memberReportConfig}
              handleConfigSave={handleMemberReportConfigSave}
              isLoading={isLoading}
            />
            <CaseConfigForm
              title={t("page.uptoFrequencyTitle", { business })}
              description={t("page.usageDescription")}
              configLabel={t("page.visitsLabel")}
              configName={CaseHandlerTypes.uptoFrequency}
              configData={memberReportConfig}
              handleConfigSave={handleMemberReportConfigSave}
              isLoading={isLoading}
            />
          </Box>
        )}
        {tab === MemberReportTabsEnum.Monetary && (
          <>
            <Box>
              <CaseConfigForm
                title={t("page.withinTotalSpendTitle", { business })}
                description={t("page.usageDescription")}
                configName={CaseHandlerTypes.withinTotalSpend}
                configLabel={t("page.amountLabel")}
                configData={memberReportConfig}
                handleConfigSave={handleMemberReportConfigSave}
                isLoading={isLoading}
              />
            </Box>
            <Box>
              <CaseConfigForm
                title={t("page.uptoTotalSpendTitle", { business })}
                description={t("page.usageDescription")}
                configName={CaseHandlerTypes.uptoTotalSpend}
                configLabel={t("page.amountLabel")}
                configData={memberReportConfig}
                handleConfigSave={handleMemberReportConfigSave}
                isLoading={isLoading}
              />
            </Box>

            <Box>
              <CaseConfigForm
                title={t("page.uptoMrpTitle", { business })}
                description={t("page.usageDescription")}
                configLabel={t("page.amountLabel")}
                configName={CaseHandlerTypes.uptoMRP}
                configData={memberReportConfig}
                handleConfigSave={handleMemberReportConfigSave}
                isLoading={isLoading}
              />
            </Box>
          </>
        )}

        {tab === MemberReportTabsEnum.Hierarchy && (
          <Box>
            <ProductHiearchyForm
              title={t("page.productHierarchyTitle", { business })}
              description={t("page.productHierarchyDescription")}
              data={memberReportConfig}
              setData={handleMemberReportConfigSave}
              isLoading={isLoading}
            ></ProductHiearchyForm>
          </Box>
        )}
        {tab === MemberReportTabsEnum.AnalysisPeriod && (
          <Box>
            <CustomerAnalysisPeriodForm
              title={t("page.analysisPeriodTitle", { business })}
              description={t("page.usageDescription")}
              data={memberReportConfig}
              setData={handleMemberReportConfigSave}
              isLoading={isLoading}
            ></CustomerAnalysisPeriodForm>
          </Box>
        )}
      </Box>
    </Box>
  );
}
